/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */

import { AxiosResponse } from 'axios';

import { path } from 'rambda';

import { defineModule } from 'direct-vuex';
import { modActionCtx, modGetterCtx } from '@/store/index';
import { api } from '@/utils/apiInstance';

import {
  basicOfficeFetch, getFetchState, FetchStateInterface, getFetchMutations,
} from '@/store/storeUtils';
import {
  PENDING, REJECTED,
} from '@/utils/statuses';
import { UserBalance } from '@/interfaces/UserBalanceTypes';
import { MultitransactionResponse } from './multitransactionsStore';

export type LinearResponse = AxiosResponse<{ data: UserBalance }>;

const userBalanceStore = defineModule({
  namespaced: true,
  state: {
    ...getFetchState<LinearResponse>(),
  } as FetchStateInterface<MultitransactionResponse>,

  getters: {
    data(...args): UserBalance | undefined {
      const { state } = getterCtx(args);

      const result = path('data.data', state.response) as UserBalance;

      return result;
    },
  },
  mutations: {
    ...getFetchMutations(),
  },
  actions: {

    async fetch(ctx) {
      const { commit, state } = actionCtx(ctx);

      if (state.fetchState === PENDING) {
        return;
      }

      await basicOfficeFetch({
        method: api.office.sendPost,
        props: {
          url: '/user/balance',
          data: {},
        },
        setState: commit.SET_STATE,
        // update state
        callback: (fetchState) => {
          if (fetchState === REJECTED) {
            console.error('Fetch error in userBalanceStore.fetch, status: ', REJECTED);
          }
        },
      });
    },
  },
});

export default userBalanceStore;
const getterCtx = (args: [any, any, any, any]) => modGetterCtx(args, userBalanceStore);
const actionCtx = (ctx: any) => modActionCtx(ctx, userBalanceStore);
